import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const DeleteCourseMutation = graphql.persisted(
  "DeleteCourse",
  graphql(`
    mutation DeleteCourse($input: DeleteCourseInput!) {
      deleteCourse(input: $input) {
        success
        blockingClassOfferings {
          id
          displayName
          section
          term {
            id
            name
          }
        }
        userErrors {
          message
          path
          code
        }
      }
    }
  `)
);

export { DeleteCourseMutation };

export function useDeleteCourse() {
  return useMutation(DeleteCourseMutation);
}
